  <!-- Conteneur principal du modal -->
<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[10000] mt-[-30%]" (click)="onBackdropClick($event)">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden" (click)="$event.stopPropagation()">
    <!-- En-tete du modal avec bouton de fermeture -->
    <div class="flex justify-between items-center px-6 py-4 border-b border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800">{{ title }}</h2>
      <button class="text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none"
              (click)="onClose()"
              aria-label="Fermer">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <!-- Corps du modal -->
    <div class="px-6 py-5">
      <p class="text-gray-600" [class]="messageClasses">{{ message }}</p>
    </div>

    <!-- Pied du modal avec boutons -->
    <div class="px-6 py-4 bg-gray-50 flex justify-end space-x-3">
      <button class="{{Skin.btnPrimary}} uppercase py-2 px-2"
              (click)="onYes()" data-testid="alert-yes">
        {{ yesButtonText }}
      </button>
      <button class="{{Skin.btnAlert}} uppercase py-2 px-2"
              (click)="onNo()" data-testid="alert-no">
        {{ noButtonText }}
      </button>
    </div>
  </div>
</div>
